var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isShow)?_c('div',{staticClass:"page-component-up",on:{"click":_vm.getTop}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }